import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { ReactComponent as ThreeDIcon } from '../../assets/3dIcon.svg'
import { ReactComponent as CorePrintIcon } from '../../assets/CorePrintIcon.svg'
import { ReactComponent as LargeFormatIcon } from '../../assets/LargeFormatIcon.svg'
import { ReactComponent as PersonalSystemsIcon } from '../../assets/PersonalSystemsIcon.svg'
import { ReactComponent as SuppliesIcon } from '../../assets/Supplies.svg'

import { getIconSize } from './helpers/getIconSize'
import { TOfferingsIconSizes } from './models/icon'

interface IOfferingIconProps {
  offering: ProgramTypes
  sizes?: TOfferingsIconSizes
}

export const OfferingIcon = ({ offering, sizes }: IOfferingIconProps) => {
  const selectedIconSize = getIconSize({
    offering,
    sizesMap: sizes,
  })

  if (offering === ProgramTypes.CorePrint || offering === ProgramTypes.Print) {
    return <CorePrintIcon {...selectedIconSize} />
  }
  if (offering === ProgramTypes.Printing3D) {
    return <ThreeDIcon {...selectedIconSize} />
  }

  if (offering === ProgramTypes.LargeFormat || offering === ProgramTypes.LF) {
    return <LargeFormatIcon {...selectedIconSize} />
  }

  if (offering === ProgramTypes.PersonalSystems || offering === ProgramTypes.PC) {
    return <PersonalSystemsIcon {...selectedIconSize} />
  }

  if (offering === ProgramTypes.Supplies) {
    return <SuppliesIcon {...selectedIconSize} />
  }

  return null
}
